import React from 'react';
import { Layout, Empty, Drawer, Affix, Button, Icon } from 'antd';
import { css } from '@emotion/css';

import { SelectedFilters } from '@appbaseio/reactivesearch';
import BookList from '../components/BookList';
import Navbar from '../components/Navbar';
import CustomSelectedFilters from '../components/CustomSelectedFilters';
import Filters from '../components/Filters';

const { Content, Sider } = Layout;

const resultStats = css`
	margin: 10px 0;
	color: #595959;
	font-weight: 400;
`;

/*

	** Sider/Drawer **
	This page is mobile responsive and we show a Drawer in
	Screen less than 576px, or else we show a sidebar.

	Sider and Drawer are use to display the necessary Filters.

	** Content **
	Whereas Content is used to display the Results using BookList &
	SelectedFilters using CustomSelectedFilters.

*/

class Search extends React.Component {
	state = {
		isDrawer: false,
	};

	handleDrawer = () => {
		this.setState(prevState => ({
			isDrawer: !prevState.isDrawer,
		}));
	};

	render() {
		const { isDrawer } = this.state;
		return (
			<React.Fragment>
				<Navbar hideShowButton searchId="Search" />
				<Layout>
					{window.innerWidth > 576 ? (
						<Sider
							width={300}
							style={{
								overflow: 'auto',
								height: 'calc(100vh - 64px)',
								position: 'fixed',
								left: 0,
								background: 'white',
							}}
						>
							<Filters />
						</Sider>
					) : (
						<Drawer
							title="Apply Filters"
							closable
							onClose={this.handleDrawer}
							visible={isDrawer}
							width={320}
						>
							<Filters />
						</Drawer>
					)}

					<Layout style={window.innerWidth > 576 ? { marginLeft: 300 } : {}}>
						<Content
							style={{
								margin: '0 16px 0',
								overflow: 'initial',
								minHeight: 'calc(100vh - 64px)',
							}}
						>
							<SelectedFilters
								render={props => <CustomSelectedFilters {...props} />}
							/>

							<BookList
								reactiveListProps={{
									react: {
										and: ['Ratings', 'Series', 'Authors', 'Search', 'Year'],
									},
									size: 8,
									loader: null,
									renderResultStats(stats) {
										return (
											<p className={resultStats}>
												{`Found ${stats.numberOfResults} books in ${
													stats.time
												} ms`}
											</p>
										);
									},
									renderNoResults() {
										return <Empty description="No Results" />;
									},
								}}
								cardProps={{
									style: {
										marginBottom: '24px',
									},
								}}
							/>
							{window.innerWidth < 576 && (
								<Affix offsetBottom={0}>
									<Button
										block
										style={{ borderRadius: 0 }}
										type="primary"
										onClick={this.handleDrawer}
									>
										<Icon type="filter" />
										Show Filters
									</Button>
								</Affix>
							)}
						</Content>
					</Layout>
				</Layout>
			</React.Fragment>
		);
	}
}

export default Search;
